/**
 * src/lib/nav/dealNav.js — TICKET-209 (CEO 2026-06-18).
 *
 * Race-free "open deal D" request — the pipeline mirror of projectNav. Lets a
 * shared `/deal/<id>` link (e.g. WhatsApp'd to a teammate so they can visit the
 * boat) open that deal's detail drawer directly, even when the link lands on a
 * cold boot before PipelineView has mounted. The request PERSISTS until
 * PipelineView consumes it; peek/consume keeps it idempotent.
 */

let pending = null;
const listeners = new Set();

/** Request that PipelineView open `dealId`. */
export function requestDealOpen(dealId) {
  if (!dealId) return;
  pending = { dealId };
  listeners.forEach((l) => {
    try { l(); } catch { /* spine-emit-ok: a listener error must not break navigation */ }
  });
}

/** Read the pending request without clearing it (so a failed open can retry). */
export function peekDealOpen() { return pending; }

/** Read + clear the pending request (call only once you've handled it). */
export function consumeDealOpen() { const p = pending; pending = null; return p; }

/** Subscribe to new requests; returns an unsubscribe fn. */
export function subscribeDealOpen(cb) { listeners.add(cb); return () => listeners.delete(cb); }

/** Test helper. */
export function _resetDealNav() { pending = null; listeners.clear(); }
